export default function CheckOut () {
  return (
    <div className='section'>
      <article className='check-out'>
        <h2>CheckOut</h2>
        <p>Sección en desarrollo 💻</p>
      </article>
    </div>
  )
}
